import { useOpen } from "../../../../../../../libs/hooks";
import { useWorkflowTruckStore } from "../../../../../store";
import {
  Grid,
  Typography,
} from "@mui/material";
import { OnlyPhoto } from "../../../../../../../libs/shared";
import { useWidth } from "../../../../../../../libs/hooks";


export const Contenedor = () => {
  const widthFull = useWidth();


  const {
    open: openPaInt1,
    handleClose: handleClosePaInt1,
    handleOpen: handleOpenPaInt1,
  } = useOpen();

  const {
    open: openPaInt2,
    handleClose: handleClosePaInt2,
    handleOpen: handleOpenPaInt2,
  } = useOpen();

  const {
    open: openPaInt3,
    handleClose: handleClosePaInt3,
    handleOpen: handleOpenPaInt3,
  } = useOpen();

  const {
    open: openPaInt4,
    handleClose: handleClosePaInt4,
    handleOpen: handleOpenPaInt4,
  } = useOpen();

  const {
    open: openPaInt5,
    handleClose: handleClosePaInt5,
    handleOpen: handleOpenPaInt5,
  } = useOpen();


  const {
    open: openPaInt6,
    handleClose: handleClosePaInt6,
    handleOpen: handleOpenPaInt6,
  } = useOpen();

  const {
    open: openPaInt7,
    handleClose: handleClosePaInt7,
    handleOpen: handleOpenPaInt7,
  } = useOpen();

  const {
    open: openPaInt8,
    handleClose: handleClosePaInt8,
    handleOpen: handleOpenPaInt8,
  } = useOpen();

  
  const photo1 = useWorkflowTruckStore(
    (state) => state.photo1
  );
  const photo2 = useWorkflowTruckStore(
    (state) => state.photo2
  );
  const photo3 = useWorkflowTruckStore(
    (state) => state.photo3
  );
  const photo4 = useWorkflowTruckStore(
    (state) => state.photo4
  );
  const photo5 = useWorkflowTruckStore(
    (state) => state.photo5
  );
  const photo6 = useWorkflowTruckStore(
    (state) => state.photo6
  );
  const photo7 = useWorkflowTruckStore(
    (state) => state.photo7
  );
  const photo8 = useWorkflowTruckStore(
    (state) => state.photo8
  );

 
  const setPhoto1 = useWorkflowTruckStore(
    (state) => state.setPhoto1
  );
  const setPhoto2 = useWorkflowTruckStore(
    (state) => state.setPhoto2
  );
  const setPhoto3 = useWorkflowTruckStore(
    (state) => state.setPhoto3
  );
  const setPhoto4 = useWorkflowTruckStore(
    (state) => state.setPhoto4
  );
  const setPhoto5 = useWorkflowTruckStore(
    (state) => state.setPhoto5
  );
  const setPhoto6 = useWorkflowTruckStore(
    (state) => state.setPhoto6
  );
  const setPhoto7 = useWorkflowTruckStore(
    (state) => state.setPhoto7
  );
  const setPhoto8 = useWorkflowTruckStore(
    (state) => state.setPhoto8
  );
  

  return (
    <Grid
      container
      spacing={0}
      justifyContent="space-around"
      sx={{
        borderBottom: "1px dashed gainsboro",
        borderRadius: 2,
        position: "relative",
        mt:2,
        width:"100%",
      }}
    >
      {/* <Typography
        sx={{
          position: "absolute",
          top: -10,
          left: 5,
          color: "dimgray",
          fontWeight: "bolder",
        }}
      >
        CARGA EN CAMIÓN
      </Typography> */}
      <Grid item xs={9} lg={5} sx={{m:2}}>
        <OnlyPhoto
          foto={photo1}
          handleClose={handleClosePaInt1}
          handleOpen={handleOpenPaInt1}
          label="CAJAS"
          open={openPaInt1}
          setFoto={setPhoto1}
          width={widthFull === "xs" ? 180 : 130}
        />
      </Grid>
      <Grid item xs={9} lg={5} sx={{m:2}}>
        <OnlyPhoto
          foto={photo2}
          handleClose={handleClosePaInt2}
          handleOpen={handleOpenPaInt2}
          label="CAMIÓN"
          open={openPaInt2}
          setFoto={setPhoto2}
          width={widthFull === "xs" ? 180 : 130}
        />
      </Grid>
      <Grid item xs={9} lg={5} sx={{m:2}}>
        <OnlyPhoto
          foto={photo3}
          handleClose={handleClosePaInt3}
          handleOpen={handleOpenPaInt3}
          label="CIERRE CAMIÓN"
          open={openPaInt3}
          setFoto={setPhoto3}
          width={widthFull === "xs" ? 180 : 130}
        />
      </Grid>
      <Grid item xs={9} lg={5} sx={{m:2}}>
        <OnlyPhoto
          foto={photo4}
          handleClose={handleClosePaInt4}
          handleOpen={handleOpenPaInt4}
          label="SELLO 1"
          open={openPaInt4}
          setFoto={setPhoto4}
          width={widthFull === "xs" ? 180 : 130}
        />
      </Grid>
      <Grid item xs={9} lg={5} sx={{m:2}}>
        <OnlyPhoto
          foto={photo5}
          handleClose={handleClosePaInt5}
          handleOpen={handleOpenPaInt5}
          label="SELLO 2"
          open={openPaInt5}
          setFoto={setPhoto5}
          width={widthFull === "xs" ? 180 : 130}
        />
      </Grid>
      <Grid item xs={9} lg={5} sx={{m:2}}>
        <OnlyPhoto
          foto={photo6}
          handleClose={handleClosePaInt6}
          handleOpen={handleOpenPaInt6}
          label="TARJA DE CARGA"
          open={openPaInt6}
          setFoto={setPhoto6}
          width={widthFull === "xs" ? 180 : 130}
        />
      </Grid>
      <Grid item xs={9} lg={5} sx={{m:2}}>
        <OnlyPhoto
          foto={photo7}
          handleClose={handleClosePaInt7}
          handleOpen={handleOpenPaInt7}
          label="GUÍA TRANSPORTE"
          open={openPaInt7}
          setFoto={setPhoto7}
          width={widthFull === "xs" ? 180 : 130}
        />
      </Grid>
      <Grid item xs={9} lg={5} sx={{m:2}}>
        <OnlyPhoto
          foto={photo8}
          handleClose={handleClosePaInt8}
          handleOpen={handleOpenPaInt8}
          label="EVALUACIÓN DE FRUTA"
          open={openPaInt8}
          setFoto={setPhoto8}
          width={widthFull === "xs" ? 180 : 130}
        />
      </Grid>
    </Grid>
  );
};
